import * as ActionTypes from '@/store/mutations/site/type'

export default {
  siteInit: ({ commit }, params) => {
    commit(ActionTypes.SITE_INIT, params)
  },
  // 注销
  siteChange: ({ commit }, params) => {
    commit(ActionTypes.SITE_CHANGE, params)
  },
  siteChangeConfigSiteSeo: ({ commit }, params) => {
    commit(ActionTypes.SITE_CHANGE_CONFIG_SITESEO, params)
  },
  // 修改站点配置 s_config
  siteConfigChange: ({ commit }, params) => {
    commit(ActionTypes.SITE_CONFIG_CHANGE, params)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/site/site.js